<template>
  <div id="userinfo">
    <el-row :gutter="20">
      <el-col :span="6" :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
         <div class="baseinfo">
            <div class="baseinfo-title">基础信息</div>
            <div class="baseinfo-line">ID号：{{form.id}}</div>
            <div class="baseinfo-line">会员：{{form.username}}</div>
            <div class="baseinfo-line">姓名：{{form.realname}}</div>
            <div class="baseinfo-line">手机：{{form.mobile}}</div>
            <div class="baseinfo-line">级别：{{form.levelname}}</div>
            <div class="baseinfo-line" @click="goUserInfo(form.parentid)">上阶：{{form.parentname}}</div>
            <div class="baseinfo-line">银行卡：{{form.bankcard}}</div>
            <div class="baseinfo-line nobot">支付宝：{{form.alipay}}</div>
         </div>
      </el-col>
      <el-col :span="18" :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="用户管理" name="user">
            <el-form ref="form" :model="form" label-width="80px">
              <el-form-item label="会员名">
                <el-input v-model="form.username"></el-input>
              </el-form-item>
              <el-form-item label="姓名">
                <el-input v-model="form.realname"></el-input>
              </el-form-item>
              <el-form-item label="密码">
                <el-input v-model="form.password" type='password'></el-input>
              </el-form-item>
              <el-form-item label="手机">
                <el-input v-model="form.mobile"></el-input>
              </el-form-item>
              <el-form-item label="级别">
                <el-select v-model="form.level" placeholder="请选择会员级别">
                  <el-option v-for='item in levelnames' :key="item.level" :label="item.name" :value="item.level"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="上阶">
                <el-input placeholder="请输入上阶ID" v-model="parentid" style="width:220px;">
                  <template slot="append"><span @click="goUserInfo(form.parentid)">{{form.parentname}}</span></template>
                </el-input>
              </el-form-item>
              <el-form-item label="业绩奖">
                <el-input placeholder="请输入业绩提成比例" v-model="yjratio" style="width:220px;">
                  <template slot="append"><span>说明:0.10即10%</span></template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSave">更新</el-button>
                <el-button @click="goBack">取消</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="库存汇总" name="stock">
            <el-table
              :data="stock"
              style="width: 100%">
              <el-table-column
                prop="name"
                label="商品"
                >
              </el-table-column>
              <el-table-column
                prop="stock"
                label="数量"
               >
              </el-table-column>
            </el-table>
         </el-tab-pane>
          <el-tab-pane label="库存历史" name="stockhistory">
                <el-table
                  :data="stockhistory"
                  style="width: 100%">
                  <el-table-column
                    prop="date"
                    label="日期"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="typename"
                    label="类型"
                   >
                  </el-table-column>
                  <el-table-column
                    prop="orderid"
                    label="订单号"
                   >
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="商品">
                  </el-table-column>
                  <el-table-column
                    prop="stocknums"
                    label="数量">
                  </el-table-column>
                </el-table>
          </el-tab-pane>
          <el-tab-pane label="下阶会员" name="member">
            <el-tabs tab-position="left" style="height: 400px;"  @tab-click="handleSwitchLevel">
              <el-tab-pane v-for="item in levelnames" :label="item.name"  :key="item.level" :name="item.level.toString()"></el-tab-pane>
              <el-table
                  :data="memberlist"
                  style="width: 100%">
                  <el-table-column
                    prop="username"
                    label="会员名"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="levelname"
                    label="级别"
                    >
                  </el-table-column>
                </el-table>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'userinfo',
  data(){
     return {
      activeName: 'user',
      form:{},
      stock:[],
      stockhistory:[],

      levelnames:[],
      memberlist:[],
      searchlevel:0,
      parentid:'',
      yjratio:0
     }
  },
  created() {
     this.getList()
  },
  methods: {
    handleClick(tab) {
        let tabname=tab.name
        if(tabname=='user'){
            this.getList()
        }else if(tabname=='stock'){
            this.getStockList()
        }else if(tabname=='stockhistory'){
            this.getStockHistory()
        }else if(tabname=='member'){
            this.getMemberList()
        }
    },
    handleSwitchLevel(tab){
       this.searchlevel=tab.name
       this.getMemberList() 
    },
    getList(){
       this.$post("/user/getPageUserInfo",{userid:this.$route.query.userid}).then((data)=>{
          if(data.result.success){
             this.form=data.result.info.userinfo
             this.levelnames=data.result.info.levelnames
             this.parentid=this.form.parentid
             this.yjratio=this.form.yjratio
          }
       })
    },
    goUserInfo(userid){
        this.$go("/userinfo?userid="+userid)
        this.getList()
    },
    getStockList(){
      this.$post("/user/getPageStockList",{userid:this.$route.query.userid}).then((data)=>{
          if(data.result.success){
             this.stock=data.result.info
          }
       })
    },
    getStockHistory(){
      this.$post("/user/getPageStockHistory",{userid:this.$route.query.userid}).then((data)=>{
          if(data.result.success){
             this.stockhistory=data.result.info
          }
       })
    },
    getMemberList(){
      this.$post("/user/getPageMemberList",{userid:this.$route.query.userid,level:this.searchlevel}).then((data)=>{
          if(data.result.success){
             this.memberlist=data.result.info.memberlist
             this.levelnames=data.result.info.levelnames
          }
       })
    },
    onSave(){
      if(this.form.username==''){
        this.$message.error("会员名不能为空");return false;
      }
      if(this.form.password==''){
        this.$message.error("密码不能为空");return false;
      }
      if(this.form.mobile==''){
        this.$message.error("手机号码不能为空");return false;
      }
      if(this.parentid==''){
        this.$message.error("上阶ID不能为空");return false;
      }

      if(this.yjratio>=1 ||this.yjratio<0){
        this.$message.error("比例设置非法");return false;
      }
      
      if(this.parentid!=this.form.parentid||this.yjratio!=this.form.yjratio){
          this.$confirm('调整会影响所有人本月业绩积分, 是否继续?', '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
             if(this.parentid!=this.form.parentid) this.form.parentid=this.parentid
             if(this.yjratio!=this.form.yjratio) this.form.yjratio=this.yjratio
             this.doSave()
          }).catch(() => {
             this.parentid=this.form.parentid      
          });
      }else{
             this.doSave()
      }
    },
    goBack(){
      this.$router.go(-1)
    },
    doSave(){
      this.$post("/user/savePageUserInfo",{userid:this.$route.query.userid,data:this.form}).then((data)=>{
          if(data.result.success){
             this.$message.success(data.result.info)
          }else{
             this.$message.error(data.result.info)
          }
       })
    }  
  }
}
</script>

<style scoped lang="scss">
.baseinfo{border-radius: 5px;border:1px solid #E4E7ED;}
.baseinfo-line{border-bottom: 1px dashed #E4E7ED;padding: 10px;font-size:14px;}
.baseinfo-title{border-bottom: 1px solid #E4E7ED;padding: 18px;font-size: 18px;}
.nobot{border-bottom: none;}
.el-tabs--left, .el-tabs--right{overflow: auto;}
</style>
